// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__35nPX","copyrightText":"footer_copyrightText__133su","footerTexts":"footer_footerTexts__1jTOD"};